import "./Footer.css";
import {
  FaFacebook,
  FaXTwitter,
  FaInstagram,
  FaYoutube,
  FaLinkedin
} from "react-icons/fa6";
import { useEffect, useState } from "react";

function Footer() {
  const [atBottom, setAtBottom] = useState(false);

  useEffect(() => {
    function handleScroll() {
      const scrollY = window.scrollY || window.pageYOffset;
      const windowH = window.innerHeight;
      const bodyH = document.body.offsetHeight;
      setAtBottom(scrollY + windowH >= bodyH - 10);
    }
    window.addEventListener("scroll", handleScroll);
    handleScroll();
    return () => window.removeEventListener("scroll", handleScroll);
  }, []);

  return (
    <footer
      className={`footer${atBottom ? " footer--static footer--at-bottom" : ""}`}
    >
      <div className="footer-top">
        <div className="footer-logo-address">
          <img
            src="/images/serdivanlogo.webp"
            alt="Serdivan Belediyesi"
            className="footer-logo"
            width="244"
            height="250"
            loading="lazy"
            decoding="async"
          />
          <div>
            <p className="footer-title">
              <b>Serdivan Belediyesi</b>
            </p>
            <p>
              <a
                href="https://maps.app.goo.gl/cVXM3K1nx4hvjbZLA"
                target="_blank"
                rel="noopener noreferrer"
                style={{ color: "inherit", textDecoration: "none" }}
              >
                Arabacıalanı Mah. No: 328, Serdivan / Sakarya
              </a>
            </p>
            <p>
              <b>Tel:</b>{" "}
              <a href="tel:4445450" style={{ color: "inherit", textDecoration: "none" }}>
                444 54 50
              </a>
              <br />
              <b>E-posta:</b>{" "}
              <a href="mailto:info@serdivan.bel.tr" style={{ color: "inherit", textDecoration: "none" }}>
                info@serdivan.bel.tr
              </a>
            </p>
          </div>
        </div>
        {/* Social + App Download Container */}
        <div className="footer-social-app-container">
          <div className="footer-social">
            <a
              href="https://www.facebook.com/serdivanbld/"
              target="_blank"
              rel="noopener noreferrer"
              aria-label="Serdivan Belediyesi Facebook sayfası"
              title="Facebook"
            >
              <FaFacebook aria-hidden="true" />
            </a>
            <a
              href="https://x.com/serdivanbld"
              target="_blank"
              rel="noopener noreferrer"
              aria-label="Serdivan Belediyesi X (Twitter) hesabı"
              title="X (Twitter)"
            >
              <FaXTwitter aria-hidden="true" />
            </a>
            <a
              href="https://www.instagram.com/serdivanbelediyesi"
              target="_blank"
              rel="noopener noreferrer"
              aria-label="Serdivan Belediyesi Instagram hesabı"
              title="Instagram"
            >
              <FaInstagram aria-hidden="true" />
            </a>
            <a
              href="https://www.youtube.com/@serdivanbelediye"
              target="_blank"
              rel="noopener noreferrer"
              aria-label="Serdivan Belediyesi YouTube kanalı"
              title="YouTube"
            >
              <FaYoutube aria-hidden="true" />
            </a>
            <a
              href="https://www.linkedin.com/company/serdivanbld/"
              target="_blank"
              rel="noopener noreferrer"
              aria-label="Serdivan Belediyesi LinkedIn sayfası"
              title="LinkedIn"
            >
              <FaLinkedin aria-hidden="true" />
            </a>
          </div>
          {/* App Promotion Section */}
          <div className="footer-app-promo">
            <div className="footer-app-promo-title">Hizmetlerimizi daha kolay kullanmak için mobil uygulamalarımızı indirin.</div>
            <div className="footer-app-promo-badges">
              <a href="https://play.google.com/store/apps/developer?id=Serdivan+Belediyesi&hl=en_ZA" target="_blank" rel="noopener noreferrer">
                <img src="/images/googleplay-badge.webp" alt="Google Play'den indirin" width="160" height="52" loading="lazy" className="footer-app-badge" />
              </a>
              <a href="https://apps.apple.com/tr/developer/serdivan-belediyesi/id1529972007" target="_blank" rel="noopener noreferrer">
                <img src="/images/appstore-badge.webp" alt="App Store'dan indirin" width="160" height="52" loading="lazy" className="footer-app-badge" />
              </a>
            </div>
          </div>
        </div>
      </div>
      <div className="footer-bottom">
        <p>
          &copy; {new Date().getFullYear()} Serdivan Belediyesi. Tüm hakları
          saklıdır. &nbsp;|&nbsp;
          <a href="/kvkk">KVKK</a> &nbsp;
          {/* |&nbsp;{" "} <a href="/sitemap">Site Haritası</a> */}
        </p>
        <p className="footer-dev">Site geliştirme: Bilgi İşlem Müdürlüğü</p>
      </div>
    </footer>
  );
}
export default Footer;
